import { defineBlock } from "eddev/blocks"
import { Card, cardVariants } from "@components/molecules/Cards"
import { VSpace } from "@components/layout/Spacer"
import { Col, Container, Grid } from "@components/layout/Grid"

export const meta: BlockMeta = {
  title: "Hero article",
  category: "common",
  icon: "align-wide",
  keywords: ["hero"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("news/hero-article", (props) => {
  return (
    <Container className="bg-bg wp:w-full wp:[&_.--grid]:w-full">
      <Grid>
        <Col initial={12} className="wp:w-full">
          <VSpace initial={7} tablet={3} />
          {props.article && props.style && (
            <Card
              type={props.style as keyof typeof cardVariants}
              {...props.article}
              additionalLink={props?.additionalLink ?? undefined}
            />
          )}
          <VSpace initial={7} tablet={3} />
        </Col>
      </Grid>
    </Container>
  )
})
